import { useParams } from 'react-router-dom';
import { Anchor, Paper, Stack, Text } from '@mantine/core';
import EvaSyncForm from './EvaSyncForm';
import SyncRunsTable from './SyncRunsTable';

const VALIDATOR_URL = 'https://diocesan.com/programs/validator/index.php?auth=k6sr9g832c';

const EvaSync = () => {
  const { id: churchId } = useParams<{ id: string }>();

  if (!churchId) {
    return (
      <Paper p="xl" radius="md" w="100%">
        <Text c="red">Church ID not found</Text>
      </Paper>
    );
  }

  return (
    <Paper p="xl" radius="md" w="100%">
      <Stack gap="xl">
        <EvaSyncForm churchId={churchId} />
        <Anchor href={VALIDATOR_URL} target="_blank" rel="noopener noreferrer" c="orange.6">
          Use Validator
        </Anchor>
        <SyncRunsTable churchId={churchId} />
      </Stack>
    </Paper>
  );
};

export default EvaSync;
